// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  onChangeIsMobile: ['isMobile'],
  setSteps: ['steps', 'index'],
  onSetLastValidStep: ['key', 'url'],
  onSetLastValidStepIndex: ['key'],
  onSetLastValidStepExpire: ['expire'],
  onResetLastValidStepExpire: null,
  onSetNextPage: ['nextPage'],
  onSetReferrer: ['referrer'],
  onSetUtmParams: ['utmParams'],
  refreshQuoteRequestSuccess: null,
})

export const NavigationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  // eslint-disable-line
  isMobile: false,
  //lastValidStep: 0,
  //lastValidStepExpire: '', // misto stringu Date ??
  /*lastValidStep: {
    index: 0,
    expire: '' // misto stringu Date ??
  },*/
  lastValidStep: {
    index: 0,
    expire: '', // misto stringu Date ??
  },
  nextPage: '',
  referrer: '',
  steps: [
    {
      key: 'product',
      label: 'navigation.step1',
      url: '',
    },
    {
      key: 'quotes',
      label: 'navigation.step2',
      url: '',
    },
    {
      key: 'calculator',
      label: 'navigation.step3',
      url: '',
    },
    {
      key: 'contract',
      label: 'navigation.step4',
      url: '',
    },
    {
      key: 'accept',
      label: 'navigation.step5',
      url: '',
    },
  ],
  utmParams: {},
})

/* ------------- Reducers ------------- */

export const onChangeIsMobile = (state, { isMobile }) => state.merge({ isMobile })

export const setNextPage = (state, { nextPage }) => state.merge({ nextPage })

export const setReferrer = (state, { referrer }) => state.merge({ referrer })

export const setStepsR = (state, { steps, index }) =>
  state.set('steps', steps).setIn(['lastValidStep', 'index'], index || 0)

export const setLastValidStep = (state, { key, url }) => {
  let steps = state.steps.asMutable()
  let lastValidStep = state.lastValidStep.asMutable()
  steps = steps.map((step, index) => {
    if (step.key === key) {
      step = {
        ...step,
        url,
      }
      lastValidStep.index = index
    }
    return step
  })
  return state.merge({ steps, lastValidStep })
}

export const setLastValidStepIndex = (state, { key }) => {
  let lastValidStep = state.lastValidStep.asMutable()
  state.steps.map((step, index) => {
    if (step.key === key) {
      lastValidStep.index = index
    }
  })
  return state.merge({ lastValidStep })
}

export const setLastValidStepExpire = (state, { expire }) => state.setIn(['lastValidStep', 'expire'], expire.toString())

export const resetLastValidStepExpire = (state) => state.setIn(['lastValidStep', 'expire'], '')

export const setUtmParams = (state, { utmParams }) => state.merge({ utmParams })

export const refreshQuoteRequestSuccessR = (state) => setLastValidStepIndex(state, { steps: 'quotes' })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_STEPS]: setStepsR,
  [Types.ON_CHANGE_IS_MOBILE]: onChangeIsMobile,
  [Types.ON_SET_LAST_VALID_STEP]: setLastValidStep,
  [Types.ON_SET_LAST_VALID_STEP_INDEX]: setLastValidStepIndex,
  [Types.ON_SET_LAST_VALID_STEP_EXPIRE]: setLastValidStepExpire,
  [Types.ON_RESET_LAST_VALID_STEP_EXPIRE]: resetLastValidStepExpire,
  [Types.ON_SET_NEXT_PAGE]: setNextPage,
  [Types.ON_SET_REFERRER]: setReferrer,
  [Types.ON_SET_UTM_PARAMS]: setUtmParams,
  [Types.REFRESH_QUOTE_REQUEST_SUCCESS]: refreshQuoteRequestSuccessR,
})
